import $ from 'jquery';

/**
 * Module to clear the form when field when clicked on search page
 */
class PostShareButtons {
    /**
     * constructor() scopes these methods so we can efficiently
     * attach / remove events, and cache jquery selectors.
     */
    constructor() {
        this.$socialBtns = $('.share-icon');
        this.windowWidth = 550;
        this.windowHeight = 370;
    }

    /**
     * clickListener() attaches the events to button
     * @returns {object} returns itself to support chaining
     */
    clickListener(e) {
        e.preventDefault();
        let $target = $(e.target);
        let url = $target.parent().attr('href');
        this.popupCenter(url, this.windowWidth, this.windowHeight);
        return this;
    }

    /**
     * on() attaches all events for this module to execute
     * @returns {object} returns itself to support chaining
     */
    on() {
        // this.trackEvent();
        // this.$clearBtn.on('click', this.scopedClickListener);
        this.$socialBtns.on('click', this.clickListener.bind(this));

        return this;
    }

    /**
     * off() removes all of the attached events for this module
     * and cleans up the added css. Later on we most likely will create
     * classes for this. NOT BEING USED
     */
    off() {
        this.$socialBtns.off('click', this.clickListener.bind(this));
        return this;
    }

      /**
     * popupCenter() opens up a new window. Used to create small window for sharing. Parmas url (string), width (int), height (int),
     */

    popupCenter(url, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width; // eslint-disable-line no-nested-ternary
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height; // eslint-disable-line no-nested-ternary

        var left = ((width / 2) - (w / 2)) + dualScreenLeft;
        var top = ((height / 2) - (h / 2)) + dualScreenTop;

        // https://developer.mozilla.org/en-US/docs/Web/API/Window/open
        var newWindow = window.open(url, 'FC Share', 'scrollbars=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (window.focus) {
            newWindow.focus();
        }
    }

}

export default new PostShareButtons();

